import styled from '@emotion/styled'

// export const KeapPartnerHomeWrapper = styled.div`
//   justify-content: space-between;
//   width: 100%;
//   min-height: 100%;
//   position: relative;
// `

// export const KeapPartnerMainContentContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   row-gap: 1.5rem;
//   padding: 1.5rem;
//   width: 100%;
//   flex-grow: 1;
//   align-items: center;
// `

// export const SecContainerSection = styled.div`
//   padding: 20px;
// `

// export const KeapPartnerTitle = styled.h1`
//   margin: 0;
//   width: max-content;
//   font-weight: 600;
//   font-size: 2rem;
//   text-transform: capitalize;
// `

// export const KeapPartnerHeader = styled.header`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   width: 100%;
//   max-width: 1442px;
// `

// export const KeapPartnerSection = styled.section`
//   border: 1px solid rgba(222, 226, 230, 50%);
//   padding: 1.5rem;
//   border-radius: 0.5rem;
//   display: flex;
//   flex-direction: column;
//   row-gap: 1rem;
//   width: 100%;
//   max-width: 1442px;
// `

// export const KeapPartnerSectionTitle = styled.h2`
//   margin: 0;
//   font-weight: 600;
//   font-size: 1.5rem;
//   font-family: 'Open Sans', sans-serif;
// `

// export const KeapPartnerOrangeLink = styled.a`
//   color: #ff5000;
// `

// export const ThryvColorSpan = styled.span`
//   color: #ff5000;
// `

// export const KeapPartnerArticle = styled.article`
//   display: flex;
//   flex-direction: column;
//   row-gap: 0.5rem;
//   padding-block: 1rem;
// `

// export const KeapPartnerSectionParagraph = styled.p`
//   margin: 0;
//   font-weight: 400;
//   font-size: 1.25rem;
//   font-family: 'Open Sans', sans-serif;
// `

// export const KeapPartnerImagesContainer = styled.div`
//   display: flex;
//   column-gap: 1rem;
//   width: 100%;
//   padding: 1rem;
// `

// export const KeapPartnerImageLink = styled.a`
//   display: flex;
//   flex-grow: 1;
//   height: auto;
//   width: auto;
// `

// export const KeapPartnerSidebarContainer = styled.aside`
//   border-left: 1px solid rgba(222, 226, 230, 50%);
//   padding: 1.5rem;
//   row-gap: 1rem;
//   top: 4rem;
//   bottom: 0;
// `

// export const KeapPartnerSidebarFooter = styled.div`
//   flex-grow: 1;
//   display: flex;
//   justify-content: center;
//   align-items: flex-end;
//   padding-block-end: 3.5rem;
//   opacity: 0;
//   transition: opacity 0.3s ease-in-out;
// `

// export const KeapPartnerSidebarMutedText = styled.p`
//   margin: 0;
//   width: max-content;
//   font-weight: 600;
//   font-size: 1.125rem;
//   font-family: 'Open Sans', sans-serif;
//   color: rgb(129, 129, 129);
// `

// export const KeapPartnerSidebarMutedLink = styled.a`
//   margin: 0;
//   width: max-content;
//   font-weight: 600;
//   font-size: 1.125rem;
//   font-family: 'Open Sans', sans-serif;
//   color: rgb(129, 129, 129);

//   &:hover {
//     color: rgb(129, 129, 129) !important;
//   }
// `

// export const KeapPartnerLogo = styled.div`
//   width: 40.75px;
//   height: 1.25rem;
//   background-size: contain;
//   background-color: transparent;
//   background-repeat: no-repeat;
// `

// export const ThryvLogoForResourceLink = styled.div`
//   width: 40.75px;
//   height: 1.25rem;
//   background-size: contain;
//   background-color: transparent;
//   background-repeat: no-repeat;
//   background-position: center;
// `

// export const KeapPartnerSidebarDivider = styled.div`
//   padding-block: 1rem;
// `

// export const KeapMCIconList = styled.ul`
//   display: flex;
//   column-gap: 1rem;
//   width: 100%;
//   margin: 0;
//   padding: 1rem 0 0 0;
// `

// export const KeapMCIconItem = styled.li`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   row-gap: 0.25rem;
//   flex-grow: 1;
//   width: 100%;
// `

// export const KeapMcIconImage = styled.img`
//   min-width: 4rem;
//   max-width: 4rem;
//   aspect-ratio: 1;
//   object-fit: contain;
// `

// export const KeapMCIconText = styled.p`
//   width: 100%;
//   margin: 0;
//   text-align: center;
//   font-size: 0.75rem;
//   font-weight: 600;
//   text-decoration: none;
//   color: #000;
//   line-height: 110%;
// `

// export const KeapMcAttributesContainer = styled.div`
//   flex-grow: 2;
//   display: flex;
//   column-gap: 1rem;
//   justify-content: center;
//   align-items: center;
// `

// export const KeapMcAttributesItem = styled.article`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   width: 100%;
//   flex-grow: 1;
//   row-gap: 1rem;
//   max-width: 13.75rem;
// `

// export const KeapMcAttributesItemHeader = styled.header`
//   display: flex;
//   flex-direction: column;
//   text-align: center;
//   align-items: center;
//   row-gap: 0.75rem;
// `

// export const KeapMcAttributesItemImage = styled.img`
//   width: 3.75rem;
//   height: auto;
//   aspect-ratio: 1;
// `

// export const KeapMcAttributesTextsContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   row-gap: 0.25rem;
// `

// export const KeapMcAttributesItemLabel = styled.h4`
//   margin: 0;
//   font-size: 0.75rem;
//   font-weight: 600;
//   color: #ff5000;
//   text-transform: uppercase;
//   font-family: 'Open Sans', sans-serif;
// `

// export const KeapMcAttributesItemTitle = styled.p`
//   margin: 0;
//   font-size: 1.25rem;
//   font-weight: 700;
//   font-family: 'Open Sans', sans-serif;
//   text-wrap: balance;
//   text-align: center;
//   line-height: 110%;
//   font-stretch: expanded;
// `

// export const KeapMcAttributesBulletList = styled.ul`
//   display: flex;
//   flex-direction: column;
//   margin: 0;
//   padding: 0;
//   row-gap: 0.75rem;
//   width: 100%;
// `

// export const KeapMcAttributesBulletItem = styled.li`
//   margin: 0;
//   display: flex;
//   column-gap: 0.5rem;

//   & svg {
//     min-width: 1rem;
//     max-width: 1rem;
//     min-height: 1rem;
//     max-height: 1rem;
//   }
// `

// export const KeapMcAttributesBulletItemText = styled.span`
//   font-size: 0.75rem;
//   color: rgb(129, 129, 129);
//   line-height: 120%;
// `
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------

export const CreateNShareContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #5378fc -46.22%, #29355d 61.1%);
`

export const CreateNShareContainer = styled.div`
  width: fit-content;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // Extra top space: the fixed header (64px) floats over this section.
  padding: 104px 0 40px;
  gap: 18px;
`

export const CreateNShareHeading = styled.h2`
  font-weight: 700;
  font-family: 'Open Sans', sans-serif;
  text-wrap: balance;
  text-align: center;
  font-size: 43px;
  line-height: 63px;
  letter-spacing: -0.75px;
  color: #fff;
  font-stretch: expanded;
`

export const CreateNShareSubtitle = styled.p`
  margin: 0;
  font-weight: 400;
  font-family: 'Open Sans', sans-serif;
  text-wrap: balance;
  text-align: center;
  font-size: 17px;
  line-height: 150%;
  letter-spacing: -0.75px;
  color: #fff;
  font-stretch: expanded;
`
export const KeapPartnerImage = styled.a`
  position: relative;
  display: inline-block;
  border-radius: 20px;
  box-shadow: 0px 5px 5px -3px #00000033, 0px 3px 14px 2px #0000001f,
    0px 8px 10px 1px #00000024;
  margin: 20px 0 0;
  cursor: pointer;
  .partner-video {
    display: block;
    width: 775px;
    height: 436px;
    border-radius: 20px;
    box-shadow: 0px 5px 5px -3px #00000033, 0px 3px 14px 2px #0000001f,
      0px 8px 10px 1px #00000024;
  }
`
export const KeapPartnerImagePlay = styled.img`
  border-radius: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  width: 75px;
  height: 75px;
`
export const KeapPartnerSecContentContainerWrapper = styled.div`
  font-family: 'Open Sans', sans-serif;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px;
`

export const KeapPartnerSecContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
`
export const LeftSection = styled.div`
  position: relative;
  flex: 1;
  h3 {
    width: 80%;
    fonst-size: 24px;
    font-weight: bold;
    margin-bottom: 12px;
    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
  p {
    width: 80%;
    font-size: 16px;
    margin-bottom: 20px;
  }
  ul {
    width: 80%;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    display: flex;
    align-items: center;
    font-size: 16px;
    margin: 15px 0;
    text-decoration: underline;
    color: #3c5199;
    cursor: pointer;

    svg,
    img {
      margin-right: 10px;
      width: 35px;
      height: 35px;
    }
    a {
      text-decoration: none;
      color: #007bff;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`

export const KeapPartnerSidebarSubtitle = styled.h3`
  margin: 0;
  font-weight: 700;
  font-size: 34px;
  line-height: 110%;
  font-family: 'Open Sans', sans-serif;
  letter-spacing: 0px;
`
export const KeapPartnerSidebarSubtitlePara = styled.p`
  font-size: small;
  font-weight: 400;
  color: #121212;
  font-family: Open Sans;
  line-height: 150%;
  margin: 1rem 0;
  letter-spacing: 0px;
`

export const KeapPartnerSidebarNav = styled.nav`
  width: 80%;
  list-style: none;
  padding: 0;
  margin: 0;
`

export const KeapPartnerSidebarLink = styled.a`
  display: flex;
  align-items: center;
  max-width: fit-content;
  font-size: 16px;
  margin: 15px 0;
  color: #3c5199;
  text-decoration: underline !important;
  cursor: pointer;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 150% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  gap: 10px;

  &:hover {
    color: #077ef4ff;
  }
`

export const KeapPartnerSidebarKeapLink = styled(KeapPartnerSidebarLink)`
  background-color: #b3e6b2;
  color: #1a4d19;

  & div {
    filter: brightness(50%);
  }

  &:hover {
    color: #359b31;
  }

  &:hover div {
    display: flex;
    position: relative;
    filter: brightness(100%);
  }

  &:hover div::after {
    content: '';
    position: absolute;
    width: 120%;
    height: 0.09rem;
    background-color: #359b31;
    left: 0;
    bottom: 0.1rem;
    right: 0;
  }
`

export const KeapPartnerSidebarThryvLink = styled(KeapPartnerSidebarLink)`
  &:hover {
    color: #077ef4ff;
  }

  &:hover div {
    display: flex;
    position: relative;
  }

  &:hover div::after {
    content: '';
    position: absolute;
    width: 120%;
    height: 0.09rem;
    background-color: #000;
    left: 0;
    bottom: 0.1rem;
    right: 0;
  }
`

export const NavbtnPlacement = styled.div`
  width: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  button {
    border-radius: 45px;
  }
`
export const KeapPartnerPrimaryBtn = styled.button`
  cursor: pointer;
  color: #fff;
  border: 2px solid #ff5000;
  max-width: fit-content;
  background-color: rgba(255, 80, 0);
  padding-inline: 1.5rem;
  padding-block: 0.5rem;
  border-radius: 0.25rem;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 18px;
  font-size: 14px;
  letter-spacing: 0px;
  box-sizing: border-box;
  padding: 10px 30px;
  align-items: center;
  gap: 6px;
  &:hover,
  &:focus {
    border: 2px solid #ff5000;
    background: #fff;
    color: #ff5000;
    animation-timing-function: ease-in;
  }
`

export const RightSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  img {
    max-width: 100%;
    border-radius: 20px;
    object-fit: cover;
  }
`

// Header styles
// -----------------------------------------
export const HeaderNavItemLinks = styled.div`
  font-weight: 600;
  display: flex;
  gap: 40px;
  align-items: center;
  .hn-item {
    padding: 0;
    margin: 0;
  }
`
